(function () {
  var breadcrumbs = document.getElementsByClassName('top-breadcrumb');
  if (breadcrumbs && breadcrumbs.length > 0) {
    var crumbs = breadcrumbs[0].querySelectorAll('.crumb');
    var crumbItemWidth = [];
    // count each crumb width
    for (var i = 0; i < crumbs.length; i++) {
      var itemWidth = crumbs[i].offsetWidth;
      crumbItemWidth.push(itemWidth);
    };
    var itemToCut = 1;

    function shortenBreadcrumb() {
      if (window.innerWidth < 722) {
        crumbs[0].classList.add('cut');
        checkItemsFit();
        if (breadcrumbs[0].querySelectorAll('.cut').length > 1) {
          crumbs[0].style.display = 'none';
        }
        else {
          crumbs[0].style.display = 'block';
        }
      }
      else {
        crumbs[0].classList.remove('cut');
        checkItemsFit();
      }
    }

    function checkItemsFit() {
      var crumbsWidth = 0;
      for (var i = 0; i < crumbs.length; i++) {
        crumbsWidth += crumbs[i].offsetWidth;
      };
      var width = breadcrumbs[0].offsetWidth - breadcrumbs[0].querySelector('.crumb--current-page').offsetWidth;
      var lastCrumbHeight = breadcrumbs[0].querySelector('.crumb--current-page').offsetHeight;

      if (width < crumbsWidth && lastCrumbHeight > 23) {
        crumbs[itemToCut].classList.add('cut');
        if (itemToCut < crumbs.length - 1) {
          itemToCut++;
          checkItemsFit();
        }
      }
      else if (width > crumbsWidth && width > crumbsWidth + crumbItemWidth[itemToCut] - 60) {
        crumbs[itemToCut].classList.remove('cut');
        if (itemToCut > 1) {
          itemToCut--;
          checkItemsFit();
        }
      }
    }
    shortenBreadcrumb();
    window.addEventListener('resize', shortenBreadcrumb);
  }
  
})();